import script from "./TableHeaderInvoiceHospital.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderInvoiceHospital.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderInvoiceHospital.vue?vue&type=style&index=0&id=2014d016&lang=css"

const __exports__ = script;

export default __exports__